import DiveProfile from './DiveProfile';

export default DiveProfile;
